import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import * as Common from '_common';
import * as Utils from '_utils';
import * as Styles from './Segments.module.scss';
import * as Types from './Types';
export function FrameSegments(props) {
    const isVertical = props.side === Types.FrameComponentType.Left ||
        props.side === Types.FrameComponentType.Right;
    const classes = Utils.classNames({
        [Styles.segments]: true,
        [Styles.segments_vertical]: isVertical,
        [Styles.segments_horizontal]: !isVertical,
    });
    return _jsx("div", { className: classes, children: props.children });
}
export function FrameSegment(props) {
    let content = null;
    switch (props.type) {
        case Types.FrameSegmentType.Empty:
            content = null;
            break;
        case Types.FrameSegmentType.Gap:
            content = null;
            break;
        case Types.FrameSegmentType.Simple:
            content = props.children;
            break;
        case Types.FrameSegmentType.Complex:
            content = (_jsxs(_Fragment, { children: [_jsx("div", { className: Styles.segment_before }), props.children, _jsx("div", { className: Styles.segment_after })] }));
            break;
        case Types.FrameSegmentType.ComplexEmpty:
            content = (_jsxs(_Fragment, { children: [_jsx("div", { className: Styles.segment_before }), _jsx("div", { className: Styles.segment_empty }), _jsx("div", { className: Styles.segment_after })] }));
            break;
        case undefined:
            content = props.children;
            break;
    }
    let classes = {
        [Styles.segment_empty]: props.type === Types.FrameSegmentType.Empty ||
            (props.type === undefined && props.children === undefined),
        [Styles.segment_gap]: props.type === Types.FrameSegmentType.Gap,
        [Styles.segment_simple]: props.type === Types.FrameSegmentType.Simple ||
            (props.type === undefined && props.children !== undefined),
        [Styles.segment_complex]: props.type === Types.FrameSegmentType.Complex,
    };
    classes = Common.WithCommonProps(props, classes);
    return (_jsx(Common.Component, { name: "frame-segment", className: Utils.classNames(classes), ...Common.HtmlProps(props), children: content }));
}
